import {useEffect, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";

export const AdminTuitionPaymentInfoModal = (props: { active: boolean, closeHandler: any ,paymentId:number}) => {
    const [data,setData] = useState({
        loaded:false,
        refNum:'',
        invoiceId:0,
        rrn:'',
        traceNo:'',
        securePan:'',
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/students/tuition/payments/info',
            {id:props.paymentId.toString()},
            true,
            (d: {
                result:string,
                reason:string|undefined,
                refNum:string,
                id:number,
                rrn:string,
                traceNo:string,
                securePan:string,
            })=>{
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    loaded: true,
                    invoiceId: d.id,
                    rrn: d.rrn,
                    refNum: d.refNum,
                    securePan: d.securePan,
                    traceNo: d.traceNo,
                });
            },
            ()=>ShowConnectionFailed('fa'),
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setData({
                loaded:false,
                refNum:'',
                invoiceId:0,
                rrn:'',
                traceNo:'',
                securePan:'',
            });
            fetchData();
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>اطلاعات پرداخت</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    {
                        data.loaded ?
                            <div className="add-student">
                                <label>شماره فاکتور:</label>
                                <input type="text" disabled className="form-control" style={{direction:'ltr'}}
                                       value={StringDigitsConvertToPersian(data.invoiceId)}/>
                                <div style={{height: 20}}/>
                                <label>کد مرجع:</label>
                                <input type="text" disabled style={{direction:'ltr'}}
                                       className="form-control" value={data.refNum}/>
                                <div style={{height: 20}}/>
                                <label>کد RRN:</label>
                                <input type="text" disabled
                                       style={{direction:'ltr'}}
                                       className="form-control" value={data.rrn}/>
                                <div style={{height: 20}}/>
                                <label>شماره پیگیری بانک:</label>
                                <input type="text" disabled className="form-control"
                                       style={{direction:'ltr'}}
                                       value={StringDigitsConvertToPersian(data.traceNo)}/>
                                <div style={{height: 20}}/>
                                <label>شماره کارت:</label>
                                <input type="text" disabled className="form-control" style={{direction:'ltr'}}
                                       value={StringDigitsConvertToPersian(data.securePan)}/>
                                <div style={{height: 20}}/>
                                <div className="d-flex justify-content-end align-items-center" style={{marginTop:0}}>
                                    <button className="cancel-button" onClick={props.closeHandler}>
                                        <b>بستن</b>
                                    </button>
                                </div>
                            </div> :
                            <div className="d-flex justify-content-center align-items-center"
                                 style={{padding: '100px 0'}}>
                                <div className="spinner-border" style={{color:'#2b2b2b'}}/>
                            </div>
                    }
                </div>
            </div>
        </>
    );
};